import debounce from 'debounce';

class AppResizableScreen {
  constructor($document, $window, appUtils) {
    'ngInject';

    [this.$document] = Array.from($document);
    this.$window = $window;
    this.appUtils = appUtils;
    this.body = this.$document.querySelector('body');
    this._selector = '[data-app-resizable-screen]';
    this._stopListening = () => {};
    this._listining = false;

    const debounceTime = 300;
    this._listener = debounce(this._listener, debounceTime);
    this._listener = this._listener.bind(this);
  }
  setSelector(querySelector) {
    this._selector = querySelector;
    return this;
  }
  start() {
    if (this._listining) {
      const errorMessage = 'AppResizableScreen is already running, you should change the ' +
        'selector instead of trying to run it more than once';
      throw new Error(errorMessage);
    }

    this._listining = true;
    this._stopListening = this.appUtils.attachWindowEvents('resize', this._listener);
    this.update();
  }
  update() {
    this._listener();
  }
  stop() {
    this._stopListening();
    this._listining = false;
  }
  _listener() {
    const { innerHeight } = this.$window;
    if (innerHeight) {
      const bodyHeight = this.body.offsetHeight;
      const newHeight = Math.max(bodyHeight, innerHeight);
      const elements = [...this.$document.querySelectorAll(this._selector)];
      elements.forEach((element) => {
        this._updateElementHeight(element, newHeight);
      });
    }
  }
  _updateElementHeight(element, screenHeight) {
    const newHeight = screenHeight - element.offsetTop;
    const { style: { height } } = element;
    if (!height || newHeight !== parseInt(height, 10)) {
      element.style.height = `${newHeight}px`;
    }
  }
}

export default AppResizableScreen;
